import React from 'react';

import LockLockedIcon from '@atlaskit/icon/core/lock-locked';

export const SpacePermissionsIconV2 = (): React.JSX.Element => (
	<LockLockedIcon label="" spacing="spacious" />
);
